import { Skeleton } from "@devhop/ui";

export function PricingSectionSkeleton() {
  return (
    <div
      className="mt-6 rounded-xl border bg-card"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="ກຳລັງໂຫຼດລາຄາ"
    >
      <div className="border-b px-5 py-4">
        <Skeleton className="h-6 w-52" />
        <Skeleton className="mt-2 h-3 w-64" />
      </div>
      <div className="grid lg:grid-cols-[minmax(260px,320px)_minmax(0,1fr)] lg:divide-x">
        <div className="space-y-2 border-b p-4 lg:border-b-0">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-20 w-full rounded-lg" />
          <Skeleton className="h-20 w-full rounded-lg" />
        </div>
        <div className="space-y-4 p-5">
          <Skeleton className="h-14 w-full rounded-lg" />
          <div className="grid gap-3 md:grid-cols-3">
            <Skeleton className="h-20 rounded-lg" />
            <Skeleton className="h-20 rounded-lg" />
            <Skeleton className="h-20 rounded-lg" />
          </div>
          <Skeleton className="h-48 w-full rounded-lg" />
        </div>
      </div>
    </div>
  );
}

export function PayoutsSectionSkeleton() {
  return (
    <div
      className="flex h-full min-h-40 flex-col rounded-xl border bg-card p-5"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="ກຳລັງໂຫຼດເບີກຈ່າຍ"
    >
      <Skeleton className="mb-4 h-5 w-44" />
      <Skeleton className="h-24 w-full flex-1 rounded-lg" />
    </div>
  );
}
